import * as Sentry from '@sentry/react';

// Sentry 초기화 (App.tsx에서 호출)
export const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const isProduction = process.env.NODE_ENV === 'production';

  // 프로덕션 환경에서만 활성화
  // 개발 환경에서 테스트하려면 아래 주석 해제
  if (isProduction && dsn) {
    Sentry.init({
      dsn: dsn,
      environment: process.env.NODE_ENV,
      tracesSampleRate: 0.1, // 10% 성능 모니터링
      replaysSessionSampleRate: 0.1, // 10% 세션 리플레이
      replaysOnErrorSampleRate: 1.0, // 에러 발생 시 100% 리플레이
    });
    // eslint-disable-next-line no-console
    console.log('[Sentry] Initialized in production mode');
  }
  
  // 개발 환경에서 Sentry 테스트 (선택적)
  // if (isDevelopment && dsn) {
  //   Sentry.init({
  //     dsn: dsn,
  //     environment: 'development',
  //     tracesSampleRate: 1.0,
  //     beforeSend(event) {
  //       console.log('[Sentry Dev] Would send:', event);
  //       return event; // 실제로 전송하려면 return event
  //     },
  //   });
  // }
};

// 에러 수동 전송
export const captureError = (error: Error, context?: Record<string, any>) => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureException(error, {
      extra: context,
    });
  } else {
    console.error('Error:', error, context);
  }
};

// 사용자 정보 설정
export const setUser = (userId: string, email?: string) => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.setUser({ id: userId, email });
  }
};

// 커스텀 이벤트 전송
export const captureMessage = (message: string, level: 'info' | 'warning' | 'error' = 'info') => {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureMessage(message, level);
  }
};
